import { useState } from 'react'
import { api } from '../../services/api'
import { bootstrap, startSync } from '../../services/syncEngine'
import { useAuthStore } from '../../store/authStore'
import { useTaskStore } from '../../store/taskStore'
import Modal from '../Common/Modal'

export default function ImportDecision() {
  const { user, guestSnapshot, needsImportDecision, finishImportDecision } = useAuthStore()
  const [busy, setBusy] = useState(false), [error, setError] = useState('')
  if (!user || !needsImportDecision || !guestSnapshot) return null
  const merge = async () => {
    setBusy(true); setError('')
    try {
      const result = await api<{ snapshot: any }>('/api/sync/import', { method: 'POST', body: JSON.stringify({ snapshot: guestSnapshot, mode: 'merge' }) })
      useTaskStore.getState().hydrateData(result.snapshot)
      localStorage.setItem('taskpriority_data_owner', user.id)
      finishImportDecision(); startSync()
    } catch (e) { setError(e instanceof Error ? e.message : 'Não foi possível importar.'); setBusy(false) }
  }
  const accountOnly = async () => { setBusy(true); finishImportDecision(); await bootstrap(user.id); startSync() }
  return <Modal title="Dados encontrados neste dispositivo" onClose={() => undefined}><div className="space-y-3 p-5"><p className="text-sm leading-6 text-slate-600">Você já possui dados salvos no navegador. Nada será enviado sem a sua escolha.</p>{error && <p role="alert" className="rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}<button className="btn-primary w-full" disabled={busy} onClick={merge}>Importar e mesclar</button><button className="btn-secondary w-full" disabled={busy} onClick={accountOnly}>Usar somente dados da conta</button><button className="w-full rounded-lg p-2 text-sm text-slate-600 hover:bg-slate-100" disabled={busy} onClick={() => finishImportDecision(true)}>Decidir depois</button></div></Modal>
}
